import React from "react";

interface Props {
  bootstrap?: string;
  children: React.ReactNode;
  onClick?: () => void;
  type?: "button" | "reset" | "submit";
  version?: string;
}


const Button = (props: Props) => {
  return (
    <button 
      type={props.type == undefined ? "button" : props.type}
      className={`saif-btn-${props.version} ${props.bootstrap}`}
      onClick={props.version == "disabled" ?  undefined : props.onClick}
    >
      {props.children}
    </button>
  );
}

Button.defaultProps = {
  bootstrap: "",
  className: "",
  version: "primary"
}

export default Button;
